import { render, staticRenderFns } from "./PartsBookIconButton.vue?vue&type=template&id=0339e6ed&scoped=true"
import script from "./PartsBookIconButton.vue?vue&type=script&lang=ts"
export * from "./PartsBookIconButton.vue?vue&type=script&lang=ts"
import style0 from "./PartsBookIconButton.vue?vue&type=style&index=0&id=0339e6ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0339e6ed",
  null
  
)

export default component.exports